export default theme => ({
    contentSection: {
        minHeight: "calc(100vh - 202px)",
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        backgroundColor: theme.palette.background.default
    },
    offlineContentSection: {
        minHeight: "calc(100vh - 241px)",
        display: "flex",
        flexFlow: "column",
        alignItems: "center",
        backgroundColor: theme.palette.background.default
    },
    mainPaper: {
        margin: "32px auto auto auto",
        width: "611px",
        borderRadius: "8px",
        padding: 0,
        "@media (max-width: 611px)": {
            width: "100vw",
            marginTop: "6px",
            borderRadius: 0
        }
    },
    paperContent: {
        padding: "35px 60px",
        "@media (max-width: 611px)": {
            padding: "22px 30px"
        }
    },
    paperFooter: {
        width: "100%",
        marginTop: 30,
        backgroundColor: "#e4f2fd",
        padding: "11px 60px",
        display: "flex",
        justifyContent: "space-between",
        minHeight: 71,
        alignItems: "center",
        "@media (max-width: 611px)": {
            padding: "22px 30px"
        }
    },
    after: {
        margin: "26px 0",
        width: "611px",
        "@media (max-width: 611px)": {
            width: "100%"
        }
    }
})
